export default "__VITE_ASSET__CuVdU_uz__"